import React, { useState, useEffect, useRef } from 'react'

import { Button, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getAllUploadedFile } from '../../../../redux/slice/filesUploadSlice';
import { useParams } from 'react-router-dom';
import { useDocumentUpload } from "hooks/useDocumentUpload";
import { ToastContainer } from "react-toastify";
import { fetchAllConfiguration } from "../../../../redux/slice/getAllConfigurationListSlice";
import { setActiveMenu } from "../../../../redux/slice/activeMenuSlice";

const EmpDocList = [
  { key: 'passportPhoto', label: 'Profile Photo' },
  { key: 'panCard', label: 'PAN Card' },
  { key: 'aadhaarCard', label: 'Aadhaar Card' },
  // { key: 'sign', label: 'Signature Scan' },
  { key: 'passportFrontImage', label: 'Passport Front Page' },
  { key: 'passportLastPageImage', label: 'Passport Last Page' },
  { key: 'illnessDocument', label: 'Medical/Illness Document' },

  { key: '10thMarksheet', label: '10th Standard' },
  { key: '12thMarksheet', label: '12th Standard' },

  { key: 'expCertFile', label: 'Experience Certificate' },
  { key: 'relievingLetterFile', label: 'Relieving Letter' },
  { key: 'offerLetter', label: 'Offer Letter' },
  { key: 'lastThreeMonthSalarySlip1', label: 'Salary Slip 1' },
  { key: 'lastThreeMonthSalarySlip2', label: 'Salary Slip 2' },
  { key: 'lastThreeMonthSalarySlip3', label: 'Salary Slip 3' },
  { key: 'lastThreeMonthBankStatement', label: '3-Month Bank Statement' }
]

const COLORS = {
  darkPurple: '#7b4f9d',
  bgLight: '#f4f1f8',
  cardBg: '#FFFFFF',
  inputBg: '#e9e3f0',
  btnPurple: '#c9bcf2',
  textDark: '#333333',
  border: '#ddd'
};
const UploadDocuments = () => {
  const dispatch = useDispatch();
  const params = useParams();
const { allFiles, fetchAllStatus } = useSelector((state) => state.filesUpload);
const { configurations, status } = useSelector(
  (state) => state.Configurations
);

const labelLookup = Object.fromEntries(
  EmpDocList.map(doc => [doc.key.toLowerCase(), doc.label])
);


const requiredDocMessage = configurations?.find(
  (config) => config.configName === "EMPLOYEE_REQUIRED_DOCUMENT"
)?.configValue || "";


const uploadedFileTypes = new Set(
  (allFiles || []).map(file => {
    return file.fileType.split('.')[0].trim().toLowerCase();
  })
);


const requiredDocsStatus = requiredDocMessage
  .split(',')
  .map(key => {
    const trimmedKey = key.trim().toLowerCase();
    const label = labelLookup[trimmedKey];
    
    if (!label) return null;

console.log("trimmedKey",trimmedKey);
    return {
      label: label,
      isUploaded: uploadedFileTypes.has(trimmedKey)
    };
  })
  .filter(Boolean);
  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer.forms.savedPermissions
  );


const areAllDocsUploaded = requiredDocsStatus.length > 0 && requiredDocsStatus.every(doc => doc.isUploaded);
  const { userId } = InitialPermissionData ?? {};
  const idFromParams = params?.id;

  const idToUse = idFromParams ?? userId;
  const { handleViewFile, handleFileSelect, handleFileUpload, } = useDocumentUpload({ candidateId: idToUse });
  useEffect(() => {
    if (userId) {
      dispatch(getAllUploadedFile(idToUse));
      dispatch(fetchAllConfiguration({ "config": "REQUIRED_DOCUMENTS" ?? "" })).unwrap();
    }
  }, [dispatch, idToUse]);

  const staticDocs = [
    { key: 'passportPhoto', label: 'Profile Photo' },
    { key: 'panCard', label: 'PAN Card' },
    { key: 'aadhaarCard', label: 'Aadhaar Card' },
    // { key: 'sign', label: 'Signature Scan' },
    { key: 'passportFrontImage', label: 'Passport Front Page' },
    { key: 'passportLastPageImage', label: 'Passport Last Page' },
    { key: 'illnessDocument', label: 'Medical/Illness Document' }
  ];


  const [educationList, setEducationList] = useState([
    { id: 1, type: '10th Marksheet', degreeName: '10th Standard', isStatic: true },
    { id: 2, type: '12th Marksheet', degreeName: '12th Standard', isStatic: true }
  ]);

  const [showModal, setShowModal] = useState(false);
  const [tempDegree, setTempDegree] = useState('');

  useEffect(() => {
    if (allFiles && allFiles.length > 0) {
      const uploadedCertificates = allFiles.filter(file =>
        file.fileType && file.fileType.toLowerCase().endsWith('certificate')
      );

      setEducationList(prevList => {
        const updatedList = [...prevList];

        uploadedCertificates.forEach(cert => {
          const alreadyExists = updatedList.find(
            edu => (edu.fileName || '').toLowerCase() === cert.fileType.toLowerCase()
          );

          if (!alreadyExists) {

            const cleanDegreeName = cert.fileType.toLowerCase().replace('certificate', '').toUpperCase();

            updatedList.push({
              id: cert.id,
              degreeName: cleanDegreeName,
              type: 'Degree Certificate',
              fileName: cert.fileType,
              isStatic: false
            });
          }
        });

        return updatedList;
      });

      let maxIndex = -1;


      allFiles.forEach(file => {
        if (file.fileType) {
          const match = file.fileType.match(/\.(\d+)$/);

          if (match) {
            const index = parseInt(match[1], 10);
            if (index > maxIndex) {
              maxIndex = index;
            }
          }
        }
      });

      if (maxIndex >= 0) {
        setExperienceYears(prevYears => {
          if (maxIndex + 1 > prevYears.length) {
            const updatedYears = [];
            for (let i = 0; i <= maxIndex; i++) {
              updatedYears.push({
                id: i + 1,
                yearTitle: i === 0 ? 'Year 1 (Most Recent)' : `Year ${i + 1}`
              });
            }
            return updatedYears;
          }
          return prevYears;
        });
      }
    }
  }, [allFiles]);

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setTempDegree('');
  };

  const handleAddEducation = (e) => {
    e.preventDefault();
    if (!tempDegree.trim()) return;

    const newEntry = {
      id: Date.now(),
      degreeName: tempDegree,
      fileName: `${tempDegree.replace(/\s+/g, '') || 'Degree'}Certificate`,
      isStatic: false
    };

    setEducationList([...educationList, newEntry]);
    closeModal();
  };


  const [experienceYears, setExperienceYears] = useState([
    { id: 1, yearTitle: 'Year 1 (Most Recent)' }
  ]);

  const experienceFileTypes = [
    { key: 'expCertFile', label: 'Experience Certificate' },
    { key: 'relievingLetterFile', label: 'Relieving Letter' },
    { key: 'offerLetter', label: 'Offer Letter' },
    { key: 'lastThreeMonthSalarySlip1', label: 'Salary Slip 1' },
    { key: 'lastThreeMonthSalarySlip2', label: 'Salary Slip 2' },
    { key: 'lastThreeMonthSalarySlip3', label: 'Salary Slip 3' },
    { key: 'lastThreeMonthBankStatement', label: '3-Month Bank Statement' }
  ];




  const addEducation = () => {
    const newId = educationList.length + 1;
    const degreeName = prompt("Enter Degree Name (e.g., Bachelor of Science):", "New Degree");
    if (degreeName) {
      setEducationList([...educationList, { id: newId, type: 'DegreeCertificate', degreeName, isStatic: false }]);
    }
  };

  const removeEducation = (id) => {
    setEducationList(educationList.filter(edu => edu.id !== id));
  };

  const addExperienceYear = () => {
    const nextYearNum = experienceYears.length + 1;
    setExperienceYears([...experienceYears, { id: nextYearNum, yearTitle: `Year ${nextYearNum}` }]);
  };

  const removeExperienceYear = (id) => {
    if (experienceYears.length > 1) {
      setExperienceYears(experienceYears.filter(exp => exp.id !== id));
    }
  };


  const FileUploadRow = ({ label, icon = 'bi-file-earmark-arrow-up', docKey }) => {
    console.log('docKey----', docKey)
    const fileInputRef = useRef(null);
    const uploadedFile = allFiles?.find(
      (file) => file?.fileType?.toLowerCase() === docKey?.toLowerCase()
    );
    const handleFileChange = async (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        handleFileSelect(docKey, selectedFile);
        console.log('docKey', docKey)
        try {
          await handleFileUpload(docKey, selectedFile);
          console.error("Upload successfully",);
          dispatch(getAllUploadedFile(idToUse));
        } catch (error) {
          console.error("Upload failed:", error);
        }

        event.target.value = null;
      }
    };
    const handleUploadClick = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };
    console.log("requiredDocsStatus", requiredDocsStatus)
    console.log("requiredDocMessage", requiredDocMessage)
    return (
      <div className="d-flex align-items-center justify-content-between p-2 mb-2 border rounded shadow-sm" style={{ backgroundColor: COLORS.cardBg, borderColor: COLORS.border }}>
        <div className="d-flex align-items-center">
          <div className="me-3 d-flex align-items-center justify-content-center rounded" style={{ width: '40px', height: '40px', backgroundColor: COLORS.inputBg, color: COLORS.darkPurple }}>
            <i className={`bi ${icon}`} style={{ fontSize: '1.2rem' }}></i>
          </div>
          <div className='ml-2'>
            <div className="fw-bold" style={{ fontSize: '0.8rem', color: COLORS.textDark, letterSpacing: '0.5px' }}>{label}</div>
            <div className="text-muted" style={{ fontSize: '0.75rem' }}>
              {uploadedFile ? uploadedFile.fileName : "No file selected"}
            </div>
          </div>
        </div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
          accept=".jpg,.jpeg,.png,.pdf"
        />
        {uploadedFile ? (
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              className="px-3 border-0"
              style={{ backgroundColor: COLORS.btnPurple, color: '#2d1a47', borderRadius: '15px' }}
              id={`dropdown-${docKey}`}
            >
              Actions
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => {
                handleViewFile(uploadedFile.fileType);

                console.log("View clicked for", uploadedFile)
              }
              }>View</Dropdown.Item>
              <Dropdown.Item onClick={handleUploadClick}>Edit</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <button className="btn btn-sm px-3" style={{ backgroundColor: COLORS.btnPurple, color: '#2d1a47', borderRadius: '15px' }}
            onClick={handleUploadClick}
          >
            Upload
          </button>
        )}
      </div>
    );
  }

  const SectionContainer = ({ title, onAdd, children }) => (
    <div className="card mb-5 border-0 shadow" style={{ borderRadius: '15px', backgroundColor: COLORS.cardBg }}>
      <div className="card-header bg-transparent border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
        <h3 className="mb-0 fw-normal" style={{ color: COLORS.darkPurple }}>{title}</h3>
        {onAdd && (
          <button className="btn d-flex align-items-center px-3" style={{ backgroundColor: COLORS.darkPurple, color: 'white', borderRadius: '20px' }} onClick={onAdd}>
            <i className="bi bi-plus-circle me-2 pr-2"></i> Add More
          </button>
        )}
      </div>
      <div className="card-body px-4 pb-4">
        {children}
      </div>
    </div>
  );
  return (
    <div style={{ backgroundColor: COLORS.bgLight, minHeight: '100vh' }}>
      <div className="container py-2">

        <div className="text-center">
          <p className="text-muted">Please upload clear copies of all required documents.</p>
        </div>
        {requiredDocsStatus.length > 0 && (
  <div className="text-center d-flex">
    <p className="d-flex justify-content-center flex-wrap error-msg">
      These documents are required (&nbsp;
      {requiredDocsStatus.map((doc, index) => (
        <span 
          key={index} 
          style={{ color: doc.isUploaded ? 'green' : 'inherit' }}
          
        >
          {doc.label}
          {index < requiredDocsStatus.length - 1 ? ',\u00A0' : ''}
        </span>
      ))}
      &nbsp;)
    </p>
    {areAllDocsUploaded &&!idFromParams && (
    <div className="col-12 py-2 col-lg-auto ms-lg-auto text-end">
            <button
              className="primary-btn btn btn-primary px-4 py-2 shadow-sm w-10"
              onClick={()=>{
                 dispatch(setActiveMenu({ menu: 'policies', subMenu: "summary" }))
              }}
            >
              Next
            </button>
          </div>
          )}
  </div>
)}


        <SectionContainer title="1. Personal Documents">
          <div className="row">
            {staticDocs.map(doc => (
              <div key={doc.key} className="col-md-6 col-lg-4">
                <FileUploadRow
                  label={doc.label}
                  // icon={doc.key === 'sign' ? 'bi-pen' : 'bi-person-badge'} 
                  docKey={doc.key}
                />
              </div>
            ))}
          </div>
        </SectionContainer>

        <SectionContainer title="2. Educational Qualifications" onAdd={openModal}>
          <div className="row mt-3">
            {educationList.map(edu => {
              const formattedDocKey = edu?.type?.replace(/\s+/g, '')?.toLowerCase() ?? `${edu.degreeName.replace(/\s+/g, '').toLowerCase()}certificate`;
              return (
                <div key={edu.id} className="col-md-6 col-lg-4 mb-3">
                  <div className="p-3 border rounded shadow-sm h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: COLORS.cardBg }}>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div>
                        <h6 className="mb-0 fw-bold">{edu.degreeName}</h6>
                        <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{edu.type}</span>
                      </div>
                      {!edu.isStatic && (
                        <button className="btn btn-sm btn-link text-danger p-0 border-0" onClick={() => removeEducation(edu.id)} title="Remove Degree">
                          <i className="bi bi-trash"></i>
                        </button>
                      )}
                    </div>
                    <FileUploadRow label="Marksheet / Certificate"
                      docKey={formattedDocKey}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </SectionContainer>

        <SectionContainer title="3. Employment History" onAdd={addExperienceYear}>
          {experienceYears.map((exp, yearIndex) => (
            <div key={exp.id} className="mb-4 p-4 border rounded shadow-sm" style={{ backgroundColor: COLORS.inputBg }}>

              <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom" style={{ borderColor: COLORS.border }}>
                <h5 className="mb-0 fw-bold text-uppercase" style={{ color: COLORS.darkPurple, letterSpacing: '1px' }}>
                  {exp.yearTitle}
                </h5>
                {yearIndex > 0 && (
                  <button className="btn btn-sm btn-outline-danger" style={{ borderRadius: '15px' }} onClick={() => removeExperienceYear(exp.id)}>
                    <i className="bi bi-trash me-1"></i> Remove Year
                  </button>
                )}
              </div>

              <div className="row">
                {experienceFileTypes.map(fileType => (
                  <div key={`${fileType.key}.${yearIndex}`} className="col-md-6 col-lg-4">
                    <FileUploadRow label={fileType.label} icon={fileType.key.includes('Salary') ? 'bi-cash-stack' : 'bi-briefcase'}
                      docKey={`${fileType.key}.${yearIndex}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </SectionContainer>

      </div>

      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title fw-bold" style={{ color: COLORS.darkPurple }}>Add New Education</h5>
                  <button
                    onClick={closeModal}
                    className="modal-close"
                    aria-label="Close"
                  >
                    <i className="bi bi-x-lg" style={{ fontSize: '20px', color: '#7b4f9d' }}></i>
                  </button>
                </div>

                <form onSubmit={handleAddEducation}>
                  <div className="modal-body py-4">
                    <label className="form-label fw-bold small text-muted">DEGREE / CERTIFICATE NAME</label>
                    <input
                      type="text"
                      className="form-control border-0 p-3"
                      style={{ backgroundColor: COLORS.lightPurple, borderRadius: '12px' }}
                      placeholder="e.g., Bachelor of Commerce"
                      value={tempDegree}
                      onChange={(e) => setTempDegree(e.target.value)}
                      autoFocus
                      required
                    />
                    <div className="form-text mt-2 text-muted">
                      This will create a new upload card for this specific degree.
                    </div>
                  </div>

                  <div className="modal-footer border-0 pt-0">
                    <Button type="button" variant="cancel-cta" className="btn btn-link text-muted text-decoration-none" onClick={closeModal}>
                      Cancel
                    </Button>
                    <Button
                      variant="update-cta"
                      type="submit"
                      className="btn px-4"
                      style={{ backgroundColor: COLORS.darkPurple, color: 'white', borderRadius: '12px' }}
                    >
                      Create Card
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      <ToastContainer />
    </div>
  )
}

export default UploadDocuments
